// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__CdSwd","inner":"Footer_inner__2Lqff","nextIcon":"Footer_nextIcon__1A8vi","innerLeft":"Footer_innerLeft__1DOlq"};